import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import React from "react";
import "./../index.scss";
import "./index.scss";
import { Link, useLocation } from "react-router-dom";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { InitiativeSlider } from "component/InitiativeList";
import { useEffect, useState } from "react";
import api from "api";
import Sidebar from "component/Sidebar";
import _ from "lodash";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import {ReactComponent as SVGEventIcon} from '../../../../assets/icon-calendar.svg';
import Breadcrumb from "component/Breadcrumb";
import { PageCredential } from "component/PageCredential";

const PageBrowseEvent = connect(stateMap)((props) => {

    const [eventTypes, setEventTypes] = useState(false);
    const binusCampus = props.config.campus;
    const [selectedCampus, setSelectedCampus] = useState('syahdan');
    const location = useLocation();


    useEffect(()=>{
        api('/EventType', 'get', {
            posts_per_page : -1
        })
            .then((response) => {


                setEventTypes(response.types);

            })
    }, []);
    
    return (
        <>
            <Header/>
            <PageCredential title="Event Initiatives" />
            <div className="page-browse-brand">
                <div className="browse-brand-header bg-event relative color-white">
                    <Breadcrumb
                        items={[
                            ['/', 'Crowdbees']
                            ,['Event']
                        ]}
                    />
                    <SVGEventIcon className="brand-icon"/>
                    <div className="image-box image color-event square">
                        <img src={`${process.env.PUBLIC_URL}/assets/image/bg/event/header.jpg`} alt="" />
                        <div className="image-box square"></div>
                    </div>
                    <div className="">
                        <h1 className="text-lg bold">Event</h1>
                        <div className="leading-text mt-4 text-sm">Are you looking for visitors for your event, <br /> or meet the best crew to run your event.</div>
                    </div>
                </div>
                <div className="brand-event-menus">
                    <div className=" tabs">
                        <Splide options={{
                            autoWidth : true
                            ,pagination : false
                            ,arrows : false
                        }}>
                            <SplideSlide>
                                <div className="tab active">
                                    <Link to="./" className="tab-wrapper">Event Registration</Link>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className="tab">
                                    <Link to="crew" className="tab-wrapper">Event Organizer Crew</Link>
                                </div>
                            </SplideSlide>
                        </Splide>
                    </div>
                </div>
                <div className="container">
                    <BlockHeader title="Upcoming Event" desc="Join on upcoming event"/>
                    <InitiativeSlider initiatives_args={{
                        type : 'event'
                        ,sortby : 'upcoming'
                        ,hide_passed : 1
                        ,event_look_for : 'participant'
                    }} />
                </div>
                <div className="full-h">
                    <div className="event-audience-scope">
                        <div className="event-audience-scope-item">
                            <BlockHeader title="International Event" desc="Event that has audience from multiple countries"  link={{
                                pathname : "browse" 
                                ,search : '?scope_level=internasional&event_look_for=participant'
                            }}/>
                            <div className="list-with-images">
                                <div>
                                    <div className="image-box square circle">
                                        <img src={`${process.env.PUBLIC_URL}/assets/image/bg/event/international.jpg`} alt="" />
                                    </div>
                                </div>
                                <div>
                                    <InitiativeSlider initiatives_args={{
                                        event_metadata : 1
                                        ,type : 'event'
                                        ,scope_level : 'internasional'
                                        ,event_look_for : 'participant'
                                        
                                    }} />
                                </div>
                            </div>
                        </div>
                        <div className="event-audience-scope-item">
                            <BlockHeader title="National Event" desc="The audience from multiple province in Indonesia" link={{
                                pathname : "browse" 
                                ,search : '?scope_level=nasional&event_look_for=participant'
                            }}/>
                            <div className="list-with-images">
                                <div>
                                    <div className="image-box square circle">
                                        <img src={`${process.env.PUBLIC_URL}/assets/image/bg/event/national.jpg`} alt="" />
                                    </div>
                                </div>
                                <div>
                                    <InitiativeSlider initiatives_args={{
                                        event_metadata : 1
                                        ,type : 'event'
                                        ,scope_level : 'nasional'
                                        ,event_look_for : 'participant'
                                        
                                    }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    eventTypes !== false &&   
                    <div className="container">
                        <BlockHeader title="Event Categories" desc="Contribute to event management on various category" link={{
                            pathname : "browse" 
                            ,search : '?event_look_for=participant'
                        }}/>
                        <div className="lists-cards">
                            {
                                eventTypes.map((eventType) => (
                                    <div className="lists-card" key={eventType.EventTypeID}>
                                        <div className="lists-card-wrapper">
                                            <BlockHeader title={eventType.TypeName}/>
                                            <InitiativeSlider initiatives_args={{
                                                event_metadata : 1
                                                ,type : 'event'
                                                ,event_type_id : [eventType.EventTypeID]
                                                ,event_look_for : 'participant'
                                            }}/>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                }
                <div className="container">
                    <div className="relative list-by-filter">
                        <Sidebar>
                            <div className="filters-boxes">
                                <div className="filter-box">
                                    <div className="wrapper">
                                        <span className="filter-title">
                                            BINUS Campus
                                        </span>
                                        <div className="filter-body">
                                            <ul className="filter-items">
                                                {

                                                    binusCampus.map(campus => (
                                                        <li key={campus[0]} className={`leading-text filter-item ${selectedCampus == campus[0] && 'active'}`}><a href="#"  onClick={(e) => {
                                                            e.preventDefault();

                                                            setSelectedCampus(campus[0]);

                                                        }} dangerouslySetInnerHTML={{__html : campus[1] }}></a></li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Sidebar>
                        <div>
                            <BlockHeader title="Join Event Near You" desc="Join on event that happening across all BINUS Campus" link={{
                                pathname : "browse" 
                                ,search : '?event_look_for=participant'
                            }}/>
                            {
                                binusCampus.map(campus => (
                                    selectedCampus == campus[0] &&
                                    <InitiativeSlider key={campus[0]} initiatives_args={{
                                        event_metadata  : 1
                                        ,type           : 'event'
                                        ,campus_area    : campus[0]
                                        ,event_look_for : 'participant'
                                    }} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>


            <Footer/>
        </>
    )
});

export default PageBrowseEvent;